import { UAParser } from "my-ua-parser"
import semver from "semver"

import { isInSdk } from "../../helpers/sdk"

export type CameraMethod = "native" | "native-with-upload" | "image-capture"

// TODO: is this needed anymore?
const isOldAndroidWithoutImageCaptureSdk = (function () {
  const m = navigator.userAgent.match(/IC\/(\d+.\d+.\d+)/)
  if (m) {
    const sdkVersion = m[1]
    return semver.lt(sdkVersion, "1.1.0")
  }
  return false
})()

/** iPhone or iPad, iPadOS reports a desktop Mac user agent and is told apart by touch support. */
export function isIOSDevice() {
  const osName = new UAParser(navigator.userAgent).getOS().name
  return osName === "iOS" || (osName === "Mac OS" && navigator.maxTouchPoints > 1)
}

type ResolveCameraMethodParams = {
  enableUpload?: boolean
  carSilhouetteEnabled: boolean
}

/** Picks how photos are taken on this device, the browser camera is the only one that can draw overlays. */
export function resolveCameraMethod(params: ResolveCameraMethodParams): CameraMethod {
  const { enableUpload, carSilhouetteEnabled } = params

  // HACK: ignore enableUpload in SDK because of GCP
  if (enableUpload && !isInSdk()) {
    return "native-with-upload"
  }

  const hasImageCapture = !!window.ImageCapture && !!navigator.mediaDevices?.getUserMedia
  const canUseImageCapture = hasImageCapture && !isOldAndroidWithoutImageCaptureSdk

  // iOS devices
  if (isIOSDevice()) {
    // iOS SDK webview keeps the native picker
    if (isInSdk()) {
      return "native"
    }

    // The native camera cannot draw the silhouette, so iOS uses the browser camera only with the silhouette flag
    if (!carSilhouetteEnabled) {
      return "native"
    }

    // iOS has ImageCapture since Safari 18.4
    return canUseImageCapture ? "image-capture" : "native"
  }

  // Android, desktop and Macs without touch
  return canUseImageCapture ? "image-capture" : "native"
}

/** True when photos go through the in-app camera stream, so camera permission is needed upfront. */
export function usesBrowserCamera(carSilhouetteEnabled: boolean) {
  return resolveCameraMethod({ carSilhouetteEnabled }) === "image-capture"
}
